const briefingSupportedExtensions = [
  'pdf',
  'png',
  'gif',
  'jpg',
  'jpeg',
  'svg',
  'txt',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx'
];

export default briefingSupportedExtensions;
